import React, { useEffect } from 'react';
import {
  FiAlertCircle,
  FiCheckCircle,
  FiInfo,
} from 'react-icons/fi';
import { animated } from 'react-spring';
import { ToastMessage, useToast } from '../../../contexts/ToastContext';

import './styles.css';

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  info: <FiInfo size={24} />,
  error: <FiAlertCircle size={24} />,
  success: <FiCheckCircle size={24} />,
};

const toastStyles = {
  info: {
    background: '#ebf8ff',
    color: '#3172b7'
  },
  success: {
    background: '#e6fffa',
    color: '#2e656a'
  },
  error: {
    background: '#c53030',
    color: '#fff'
  }
}

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id]);

  // type={message.type}
  //     hasdescription={message.description ? 'true' : ''}
  //     style={style}

  return (
    <animated.div className="styled-toast" style={toastStyles[message.type || 'info']}>
      {!!message.description}
      {icons[message.type || 'info']}
      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      {/* <button type="button" onClick={() => removeToast(message.id)}>
        <FiXCircle size={18} />
      </button> */}
    </animated.div>
  );
};

export default Toast;
